<template>
  <ul class="form-input">
    <li class="text-center">
      <h3 class="title">Nhập khoảng thời gian</h3>
      <ul class="nav nav-tabs t-tabs">
        <li class="nav-item t-item">
          <a href="#from-type-1" class="nav-link active" data-toggle="tab">Theo ngày</a>
        </li>
        <li class="nav-item t-item">
          <a href="#from-type-2" class="nav-link" data-toggle="tab">Theo khoảng thời gian</a>
        </li>
<!--        <li class="nav-item t-item">-->
<!--          <a href="#from-type-3" class="nav-link" data-toggle="tab">Theo Công việc</a>-->
<!--        </li>-->
      </ul>
      <div class="tab-content">
        <div class="tab-pane container active" id="from-type-1">
          <div class="form-group">
            <label>Chọn ngày</label>
            <input type="date" name="date" v-model="date" class="form-control">
          </div>
          <button class="btn btn-success" @click="onClickSubmit(1)">Gửi</button>
        </div>
        <div class="tab-pane container fade" id="from-type-2">
          <div class="form-group">
            <label>Ngày bắt đầu</label>
            <input type="date" name="from" class="form-control" v-model="startDate">
          </div>
          <div class="form-group">
            <label>Ngày kết thúc</label>
            <input type="date" name="to" class="form-control" v-model="endDate">
          </div>
          <button class="btn btn-success" @click="onClickSubmit(2)">Gửi</button>
        </div>
<!--        <div class="tab-pane container fade" id="from-type-3">-->
<!--          <div class="form-group">-->
<!--            <select name="nhom_cong_viec" class="form-control" style="margin-top: 30px"-->
<!--                    onchange="getCongViec(this)">-->
<!--              <option value="0" selected="">Chọn nhóm công việc</option>-->
<!--              <option value="1">Vấn đề tín ngưỡng (cúng, tế, lễ ...)</option>-->
<!--              <option value="2">Việc liên quan đến xã hội, tập thể</option>-->
<!--              <option value="3">Việc liên quan đến gia đình, cá nhân</option>-->
<!--              <option value="4">Việc liên quan đến sản xuất, kinh doanh (Công thương)</option>-->
<!--              <option value="5">Việc liên quan đến trồng trọt, chăn nuôi, săn bắt (Nông ngư)</option>-->
<!--              <option value="6">Việc liên quan đến tu tạo, tang táng (Tạo táng)</option>-->
<!--            </select>-->
<!--          </div>-->
<!--          <form>-->
<!--            <div class="form-group">-->
<!--              <label>Chọn công việc</label>-->
<!--              <select name="cong_viec_id" id="cong_viec" class="form-control">-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="form-group">-->
<!--              <label>Ngày bắt đầu</label>-->
<!--              <input type="date" name="from" class="form-control" value="">-->
<!--            </div>-->
<!--            <div class="form-group">-->
<!--              <label>Ngày kết thúc</label>-->
<!--              <input type="date" name="to" class="form-control" value="">-->
<!--            </div>-->
<!--            <button class="btn btn-success">Gửi</button>-->
<!--          </form>-->
<!--        </div>-->
      </div>
    </li>
  </ul>
</template>

<script>
import moment from 'moment'
export default {
  name: 'FormInput',
  data () {
    return {
      date: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      data: null
    }
  },
  methods: {
    onClickSubmit (type) {
      let dates = [this.date]
      switch (type) {
        case 1:
          break
        case 2:
          dates = [this.startDate, this.endDate]
          break
        default:
      }
      this.$emit('submit', { dates, type })
    }
  }
}
</script>

<style scoped src="../../assets/css/bootstrap2.min.css"/>
<style scoped src="../../assets/css/lichTotXau.css"/>
<style scoped>

</style>
